var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap"},[_c('div',{staticClass:"topicdetail"}),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"contentbox",domProps:{"innerHTML":_vm._s(_vm.content.content)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }